import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/index.css';
import './styles/App.css';
import './styles/Header.css';
import './styles/Footer.css';
import './styles/ScrollToTop.css';
import './styles/Home.css';
import './styles/ServicesCapabilities.css';
import './styles/CaseStudies.css';
import './styles/AboutUs.css';
import './styles/Contact.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
